module.exports = __webpack_public_path__ + "img/product_20.817d5bc.jpg";